import React,{ Component  } from "react"
import { Link, FormattedMessage, injectIntl, useIntl } from "gatsby-plugin-intl"
import BurgerBtn from '../components/BurgerBtn'
import { Collapse } from 'reactstrap';
import Language from '../components/language'

import logo from '../images/akzent-logo.svg'
import mail from '../images/icon-mail.svg'
import phone from '../images/icon-phone.svg'
// import cotizador from '../images/icon-cotizador.svg'
import numero from '../images/icon-numero.svg'
import terrestre from '../images/icon-na-terrestre.svg'
import aereo from '../images/icon-na-aereo.svg'
import maritimo from '../images/icon-na-maritimo.svg'
import almacen from '../images/icon-na-almacen.svg'
import aduanal from '../images/icon-na-aduanal.svg'
import helpdesk from '../images/helpdesk_mesaayuda.svg'

import { navigate } from "gatsby";

class Header extends Component{

	constructor(props) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.redirectblog = this.redirectblog.bind(this);
		this.state = { collapse: false };
	}

	toggle() {
		this.setState(state => ({ collapse: !state.collapse }));
	}

	getRedirectLanguage = () => {

		console.log('function language');
		if (typeof navigator === `undefined`) {
		  return "en";
		}

		console.log(this.useIntl.language);
		console.log(this.useIntl.lang);

		const lang = navigator && navigator.language && navigator.language.split("-")[0];
		console.log(lang);

		if (!lang) return "en";

		switch (lang) {
		  case "en":
			return "en";
		  default:
			return "";
		}
	};

	redirectblog(){

		const url = typeof window !== 'undefined' ? window.location.href : '';
		console.log(url);

		if(url != undefined)
			if( (url.indexOf('https://localhost:9000/es') > -1) || (url.indexOf('http://localhost:9000/es') > -1)){
				console.log('spanish');
				navigate(`https://blog.akzent.mx/`);
			}

		if(url != undefined)
			if( (url.indexOf('https://www.akzent.mx/es') > -1) || (url.indexOf('http://www.akzent.mx/es') > -1)){
				console.log('spanish');
				navigate(`https://blog.akzent.mx/`);
			}

		if(url != undefined)
			if( (url.indexOf('https://localhost:9000/en') > -1) || (url.indexOf('http://localhost:9000/en') > -1)){
				console.log('english');
				navigate(`https://blog.akzent.mx/en`);
		}

		if(url != undefined)
			if( (url.indexOf('https://www.akzent.mx/en') > -1) || (url.indexOf('http://www.akzent.mx/en') > -1)){
				console.log('english');
				navigate(`https://blog.akzent.mx/en`);
		}
	}

	render(){
		return(
			<div>
				<header className="main-header">
					<div className="cont">
						<div className="top">
							<div className="logo">
								<Link to="/">
									<img src={logo} alt="Akzent" width="145" height="39" className="img-fluid"/>
								</Link>
							</div>
							<div className="info">
								<a href="mailto:hello@akzent.mx" className="link">
									<img src={mail} alt="Mail" width="18" height="14"/>
									hello@akzent.mx
								</a>
								<a href="tel:(800)2259368" className="link">
									<img src={phone} alt="Tel" width="14" height="14"/>
									(800) 225.9368
								</a>
								<span className="divider"></span>
								<Link className="btn btn-solid verde" to="/landingapps/suite">
									<FormattedMessage id="header.acceso" />
								</Link>
								{/*<a href="https://www.akzent.mx/Account/Login.aspx" target="_blank" rel="noopener noreferrer" className="btn btn-solid verde"><FormattedMessage id="header.acceso" /></a>*/}
							</div>
							<div className="mnav-top d-md-none">
								<a href="mailto:hello@akzent.mx" className="link">
									<img src={mail} alt="Mail" width="18" height="14"/>
								</a>
								<a href="tel:01(800)2259368" className="link">
									<img src={phone} alt="Tel" width="14" height="14"/>
								</a>
								<div onClick={this.toggle}>
									<BurgerBtn/>
								</div>
							</div>
						</div>
						<hr/>
						<div className="bottom">
							<div className="main-nav">
								<nav>
									<ul>
										<li>
											<Link className="link" to="/empresa"><FormattedMessage id="header.empresa" /></Link>
										</li>
										<li className="dropmenu">
											<FormattedMessage id="header.servicios" />
											<ul className="submenu submega">
												<li>
													<Link to="/servicios/almacen-distribucion">
														<div className="icon"><img src={almacen} alt="Almacén y distribución" width="40" height="40"/></div>
														<div className="txt">
														<FormattedMessage id="header.almacen" />
														</div>
													</Link>
												</li>
												<li>
													<Link to="/servicios/transportacion-terrestre">
														<div className="icon">
															<img src={terrestre} alt="Transportación terrestre" width="40" height="22"/>
														</div>
														<div className="txt">
															<FormattedMessage id="header.terrestre" />
														</div>
													</Link>
												</li>
												<li>
													<Link to="/servicios/transportacion-maritima">
														<div className="icon"><img src={maritimo} alt="Transportación marítima" width="40" height="48"/></div>
														<div className="txt">
															<FormattedMessage id="header.maritima" />
														</div>
													</Link>
												</li>
												<li>
													<Link to="/servicios/transportacion-aerea">
														<div className="icon"><img src={aereo} alt="Transportación aérea" width="40" height="40"/></div>
														<div className="txt">
															<FormattedMessage id="header.aerea" />
														</div>
													</Link>
												</li>
												<li>
													<Link to="/servicios/agencia-aduanal">
														<div className="icon"><img src={aduanal} alt="Agencia aduanal" width="33" height="40"/></div>
														<div className="txt">
															<FormattedMessage id="header.agencia" />
														</div>
													</Link>
												</li>
											</ul>
										</li>
										<li>
											{/* <Link className="link" to="/recursos"><FormattedMessage id="header.recursos" /></Link>--> */}
											<a href="https://blog.akzent.mx/biblioteca" target="_self" className="link" ><FormattedMessage id="header.recursos" /></a>
										</li>
										<li>
											<Link className="link" to="/contacto"><FormattedMessage id="header.contacto" /></Link>
										</li>
										<li>
											<a onClick={this.redirectblog} className="link" ><FormattedMessage id="header.blog" /></a>
										</li>
									</ul>
								</nav>
							</div>
							<div className="extras">
								{/* <a href="https://www.akzent.mx/" target="_blank" rel="noopener noreferrer">
									<img src={cotizador} alt="Cotizador" width="17" height="18"/>
									Cotizador
								</a> */}
								<a href="https://global.akzent.mx" target="_blank" rel="noopener noreferrer">
									<img src={numero} alt="Número" width="17" height="15"/>
									<FormattedMessage id="header.rastrea" />
								</a>
								{/*<a href="https://arcatek.zendesk.com/hc/es-419" target="_blank" rel="noopener noreferrer">
										<img src={helpdesk} alt="Mesa ayuda" width="17" height="15"/>
										<FormattedMessage id="header.servicedesk" />
								</a>*/}
								<div className="minidrop">
									<Language/>
								</div>
							</div>
						</div>
						<hr/>
					</div>
				</header>
				<Collapse isOpen={this.state.collapse}>
					<div className="mnav-cont">
						<div className="inner">
							<nav>
								<ul>
									<li>
										<Link to="/empresa"><FormattedMessage id="header.empresa" /></Link>
									</li>
									<li>
										<span><FormattedMessage id="header.servicios" /></span>
										<ul>
											<li>
												<Link to="/servicios/almacen-distribucion">
													<FormattedMessage id="header.almacen" />
												</Link>
											</li>
											<li>
												<Link to="/servicios/transportacion-terrestre">
													<FormattedMessage id="header.terrestre" />
												</Link>
											</li>
											<li>
												<Link to="/servicios/transportacion-maritima">
													<FormattedMessage id="header.maritima" />
												</Link>
											</li>
											<li>
												<Link to="/servicios/transportacion-aerea">
													<FormattedMessage id="header.aerea" />
												</Link>
											</li>
											<li>
												<Link to="/servicios/agencia-aduanal">
													<FormattedMessage id="header.agencia" />
												</Link>
											</li>
										</ul>
									</li>
									<li>
										{/* <Link to="/recursos"><FormattedMessage id="header.recursos" /></Link> */}
										<a href="https://blog.akzent.mx/biblioteca" target="_self" className="link" ><FormattedMessage id="header.recursos" /></a>
									</li>
									<li>
										<Link to="/contacto"><FormattedMessage id="header.contacto" /></Link>
									</li>
									<li>
										<a href="https://blog.akzent.mx/" target="_self" className="link" ><FormattedMessage id="header.blog" /></a>
									</li>
								</ul>
							</nav>
							<div className="extras">
								<div className="mt-3">
									<a href="https://www.akzent.mx/Account/Login.aspx" target="_blank" rel="noopener noreferrer" className="btn btn-solid verde"><FormattedMessage id="header.acceso" /></a>
								</div>
								<div className="links">
									{/* <a href="https://www.akzent.mx/" target="_blank" rel="noopener noreferrer">
										<img src={cotizador} alt="Cotizador" width="17" height="18"/>
										Cotizador
									</a> */}
									<a href="https://global.akzent.mx/" target="_blank" rel="noopener noreferrer">
										<img src={numero} alt="Número" width="17" height="15"/>
										<FormattedMessage id="header.rastrea" />
									</a>
									{/*<a href="https://arcatek.zendesk.com/hc/es-419" target="_blank" rel="noopener noreferrer">
										<img src={helpdesk} alt="Mesa ayuda" width="17" height="15"/>
								<FormattedMessage id="header.servicedesk" />
								</a>*/ }
								</div>
								<div className="minidrop">
									<Language/>
								</div>
							</div>
						</div>
					</div>
				</Collapse>
			</div>
		)
	}
}

export default injectIntl(Header)
